module.exports = __webpack_public_path__ + "static/img/vouchers202.b997c5bc.png";